/* eslint-disable */

import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import routes from "routes.js";

const Sidebar = ({ open, onClose }) => {
  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex min-h-full flex-col bg-white pb-10 shadow-2xl shadow-orange-100/40 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      {/* Orange top accent bar */}
      <div className="absolute top-0 left-0 right-0 h-1 rounded-t-none bg-gradient-to-r from-orange-500 via-orange-400 to-orange-300" />

      <span
        className="absolute top-4 right-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>

      <div className={`mx-[56px] mt-[50px] flex items-center`}>
        <div className="mt-1 ml-1 h-2.5 font-poppins text-[26px] font-bold uppercase dark:text-white">
          <span className="text-orange-500">Tinka</span>{" "}
          <span className="font-medium text-navy-700 dark:text-white">Admin</span>
        </div>
      </div>
      <div className="mt-[58px] mb-7 h-px bg-gradient-to-r from-orange-200 via-orange-100 to-transparent dark:bg-white/30" />

      {/* Nav item */}
      <ul className="mb-auto pt-1">
        <Links routes={routes} />
      </ul>
    </div>
  );
};

export default Sidebar;
